<template>
	<div class="content">
		<div class="content_head">

			<input type="text" v-model="search" @keypress.enter="pageIndex=1;getData()" class="search"
				placeholder="地区名称|地区编码" />
			<button type="button" class="button " @click="pageIndex=1;getData()">查找</button>
			<button type="button" class="button add" @click="clear();Edit='add'">+新增</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>地区编号</th>
						<th>地区名称</th>
						<th>店铺数量</th>
						<th>修改</th>

					</tr>
				</thead>
				<tbody>

					<tr v-for="(i,index) in areas">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>{{i.areaCode}}</td>
						<td>{{i.areaName}}</td>
						<td>{{i.shopCount+'家'}}</td>

						<td>
							<button type="button" class="button" @click='updateArea(i)'>修改</button>
						</td>
					</tr>

				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>

		<div class="booksMangement" v-show="Edit!='' && Edit!='code'">
			<div v-show="Edit!=''">
				<div>
					<span class="red">*</span>地区编号:
				</div>
				<div>
					<input type="text" v-model="areaCode" placeholder="地区编号" required="required" />
					<span class="err">{{areaCode.length==0?' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>地区编号:
				</div>
				<div>
					<input type="text" v-model="areaName" placeholder="地区名称" required="required" />
					<span class="err">{{areaName.length==0?' ':'×'}}</span>
				</div>
				<div>
				</div>
				<div>

					<button class="button" :class="{'disabled':!checkArea}" :disabled="!checkArea"
						@click="editArea">{{ areaID==0?'新增':'修改'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="Edit='';clear()">取消</button>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import j from './AreaMangment.js'
	export default j
</script>

<style>

</style>
